module.exports = __webpack_public_path__ + "img/svs-dordrecht@2x.717b6f5c.jpg";